var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMailsupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 12,
    viewBox: "0 0 13 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.01731 4.98977L5.41503 7.88466C5.80706 8.14172 6.00311 8.27021 6.21498 8.32016C6.40216 8.36427 6.59735 8.36427 6.78459 8.32016C6.99647 8.27021 7.19251 8.14172 7.58454 7.88466L11.9823 4.98977M5.45995 1.42498L1.91553 3.61419C1.58129 3.82063 1.41418 3.92385 1.29297 4.06338C1.18569 4.18688 1.10496 4.33048 1.05568 4.48552C1 4.66068 1 4.85475 1 5.24292V9.07673C1 9.74993 1 10.0866 1.13322 10.3437C1.25039 10.5698 1.43737 10.7538 1.66735 10.869C1.92879 11 2.27104 11 2.95556 11H10.0444C10.7289 11 11.0712 11 11.3327 10.869C11.5626 10.7538 11.7496 10.5698 11.8668 10.3437C12 10.0866 12 9.74993 12 9.07673V5.24292C12 4.85475 12 4.66068 11.9443 4.48552C11.895 4.33048 11.8143 4.18688 11.707 4.06338C11.5858 3.92385 11.4187 3.82063 11.0845 3.61419L7.54005 1.42498C7.16281 1.19201 6.97422 1.07552 6.77188 1.03012C6.59289 0.989961 6.40711 0.989961 6.22812 1.03012C6.02578 1.07552 5.83719 1.19201 5.45995 1.42498Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailsupport);
export default __webpack_public_path__ + "static/media/mailsupport.63bf5fedeba6fee9841c699793af49f2.svg";
export { ForwardRef as ReactComponent };